import { Select } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import {
  InternalAdminEditUserMutation,
  InternalAdminEditUserMutationVariables,
  InternalAdminUserFragment,
} from "gql/graphql";
import { useMutation } from "@apollo/client";
import { UserPreferenceName } from "modules/utils/Constants";
import INTERNAL_ADMIN_EDIT_USER_MUTATION from "../_networking/internal-admin-edit-user";
import { supportedTranslationLanguages } from "modules/utils/translation";

interface IProps {
  user: InternalAdminUserFragment;
}

const userPreferenceName: UserPreferenceName = "LOCALE";

const InternalAdminEditUserLanguage = ({ user }: IProps) => {
  const [internalAdminEditUserMutationAPI] = useMutation<
    InternalAdminEditUserMutation,
    InternalAdminEditUserMutationVariables
  >(INTERNAL_ADMIN_EDIT_USER_MUTATION);

  const defaultLanguage = user.userPreferenceList.find(
    (pref) => pref.name === userPreferenceName,
  )?.value;

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      internalAdminEditUserMutationAPI({
        variables: {
          organizationId: user.organizationId,
          id: user.id,
          input: {
            userPreferenceList: [
              {
                name: "LOCALE",
                value: e.target.value,
              },
            ],
          },
        },
      });
    },
    [internalAdminEditUserMutationAPI, user.id, user.organizationId],
  );

  return (
    <Select
      placeholder="Select One"
      fontSize={14}
      defaultValue={defaultLanguage}
      onChange={onChange}
    >
      {supportedTranslationLanguages.map(([langCode, langName]) => (
        <option key={langCode} value={langCode}>
          {langName}
        </option>
      ))}
    </Select>
  );
};

export default memo(InternalAdminEditUserLanguage);
